// pages/tasks/MyTicketsListPage.jsx
//
// "My Tickets" -- tickets CREATED by the caller, EXCLUDING IT-support
// complaints (created_by = req.user.id AND task_type <> IT_SUPPORT,
// resolved by code -- see services/taskAssignmentService.js#listMyTickets).
// Distinct from "Complaints" (created_by = req.user.id AND task_type =
// IT_SUPPORT) -- task_type is the discriminator, never assignment
// direction. A ticket the caller creates may be unassigned, so this always
// uses the self-scoped GET /my-tickets regardless of the caller's
// tasks:view grant. Reuses ComplaintsListPage rather than duplicating its
// list/detail logic.
import React from "react";
import ComplaintsListPage from "./ComplaintsListPage";

export default function MyTicketsListPage() {
  return (
    <ComplaintsListPage
      scope="self-tickets"
      title="My Tasks"
      description="Tasks you created, whether or not they have been assigned yet."
    />
  );
}
